import AbstractStore from 'core/abstracts/AbstractStore';
import Dispatcher from 'core/Dispatcher';
import Constants from 'constants.js';

class ControlTowerStore extends AbstractStore {

    constructor() {

        const CHANGE_EVENT = 'CONTROL_TOWER_CHANGE_EVENT';
        const NAME = 'CONTROL_TOWER_STORE';

        super(NAME, CHANGE_EVENT);

        this._initStore();

        // Registers action handler with the Dispatcher.
        Dispatcher.register(this._registerToActions.bind(this));
    }

    _initStore() {
        this.loading = true;
        this.data = null;
        this.stats = null;
        this.params = {
            page: 1,
            rowsPerPage: 25,
            bot: 'robot_v3',
            category: 'untrusted'
        };
    }

    isLoading() {
        return this.loading;
    }

    getData() {
        return this.data;
    }

    getStats() {
        return this.stats;
    }

    getParams() {
        return this.params;
    }

    setParams(params) {
        this.params = params;
    }

    setData(data) {
        this.data = data;
    }

    setStats(stats) {
        this.stats = stats;
    }

    changeStatus = (action, newData, siteId, clickAllItems, params) => {
        this.data.sites = this.data.sites.map((site) => {
            if (siteId === site.id) {
                if (clickAllItems) {
                    site.supervisorAction = action;
                }
                site.items = site.items.map((item) => {
                    item.associatedItems = item.associatedItems.map((associatedItem) => {
                        newData.forEach((obj) => {
                            if (obj.article_id === associatedItem.articleId) {
                                if (action === 'SET_URL') {
                                    item.url = params.url;
                                    associatedItem.supervisorAction = action;
                                } else {
                                    associatedItem.currentData.originalPrice = obj.current_data.original_price ? obj.current_data.original_price : obj.current_data.price;
                                    associatedItem.currentData.price = obj.current_data.price;
                                    associatedItem.currentData.stock = obj.current_data.stock;
                                    associatedItem.supervisorAction = action;
                                    associatedItem.currentData.additionalData = obj.current_data.additional_data ? obj.current_data.additional_data : {};
                                    associatedItem.currentData.marketplaceOffers = obj.current_data.marketplace_offers ? obj.current_data.marketplace_offers : [];
                                    associatedItem.currentData.availability = obj.current_data.availability;
                                    associatedItem.currentData.imgUrl = obj.current_data.img_url;
                                }
                            }
                        });
                        return associatedItem;
                    });
                    return item;
                });

                return site;
            }
            return site;
        });
    };

    // Switches over the action's type when an action is dispatched.
    _registerToActions(action) {
        switch (action.actionType) {
        case Constants.LOGOUT:
            this._initStore();
            this._emitChange();
            break;
        case Constants.CONTROL_TOWER_GET_DATA_START:
            this.setParams(action.value);
            this.loading = true;
            this._emitChange();
            break;
        case Constants.CONTROL_TOWER_GET_STATS:
            this.setStats(action.value);
            this._emitChange();
            break;
        case Constants.CONTROL_TOWER_GET_DATA:
            this.setData(action.value);
            this.loading = false;
            this._emitChange();
            break;
        case Constants.CONTROL_TOWER_CHANGE_STATUS:
            this.changeStatus(action.value.action, action.value.newData, action.value.siteId, action.value.clickAllItems, action.value.params);
            this._emitChange();
            break;
        default:
            return false;
        }
    }

}

export default new ControlTowerStore();
